/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { UserService } from 'app/core/services/user-service';
import * as Core from 'app/core/models/essette-api';

@autoinject()
export class UserMemberFilters extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.objectNull({ changeHandler: 'loadFilters' })
    protected user: Core.User | null = null;
    @bindable()
    public readonly: boolean = false;
    protected filters: Core.Filter[] = [];
    public selectedFilters: Core.Filter[] = [];

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly userService: UserService,
        ...rest: any[]) {

        super(...rest);
    }

    protected bind() {
        this.loadFilters();
    }

    ////****************** Functions ************************************************////

    isFilterChecked(filter: Core.Filter): boolean {
        return this.selectedFilters.some(f => this.compareFilters(f, filter));
    }

    protected toggleFilter(filter: any, checked: boolean): void {
        if(checked) {
            if(!this.isFilterChecked(filter)) {
                this.selectedFilters = [...this.selectedFilters, filter]
            }
        }
        else {
            this.selectedFilters = this.selectedFilters.filter(f => !this.compareFilters(f, filter));
        }
    }

    protected compareFilters(a: Core.Filter, b: Core.Filter): boolean {
        return a.id === b.id;
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadFilters(): Promise<void> {
        if(!this.readonly) {
            const response = await this.userService.loadFilters({ all: true });
            this.filters = response.results;

            if(this.user?.filters) {
                this.selectedFilters = this.filters.filter(fil =>
                    this.user?.filters?.some(userFil => this.compareFilters(userFil, fil))
                )
            }
        }
        else {
            this.selectedFilters = [...(this.user?.filters || [])];
        }
    }
}
